// extracted by mini-css-extract-plugin
module.exports = {"w100":"ChoosePlacement_w100_3N0sS","scroll":"ChoosePlacement_scroll_2EKQZ"};